import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _styled from "@emotion/styled-base";
const _excluded = ["showHidePasswordLink"];
import React from 'react';
import { BarePasswordInput } from '@entrata/shared/lib/components/forms/inputs';
import PropTypes from 'prop-types';
import { textInputStyles } from "./styles";
import { InputButton } from "./InputButton";
import { jsx as ___EmotionJSX } from "@emotion/core";
const BoxedPassword = /*#__PURE__*/_styled(BarePasswordInput, {
  target: "evwyxpq0"
})(_ref => {
  let {
    theme
  } = _ref;
  return textInputStyles(theme);
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const hideText = __('Hide', [], {
  application_name: 'common_ui',
  namespace: 'common_password'
});
const showText = __('Show', [], {
  application_name: 'common_ui',
  namespace: 'common_password'
});
const PasswordInput = _ref2 => {
  let {
      showHidePasswordLink
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return showHidePasswordLink ? ___EmotionJSX(BoxedPassword, _extends({}, props, {
    renderShowToggle: _ref3 => {
      let {
        show,
        toggle
      } = _ref3;
      return ___EmotionJSX(InputButton, {
        tabIndex: "-1",
        "aria-hidden": "true",
        type: "button",
        onClick: toggle
      }, ___EmotionJSX("em", null, show ? hideText : showText));
    }
  })) : ___EmotionJSX(BoxedPassword, props);
};
PasswordInput.validate = BarePasswordInput.validate;
PasswordInput.inputType = BarePasswordInput.inputType;
PasswordInput.defaultProps = {
  showHidePasswordLink: false
};
PasswordInput.propTypes = {
  /** `true` if the field is currently focused */
  active: PropTypes.bool,
  /** `true` if the field state has changed from its original value */
  dirty: PropTypes.bool,
  /** Field error message */
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** Id used by label and input */
  id: PropTypes.string,
  /** Field Label */
  label: PropTypes.node,
  /** Name that the value of the input is stored as  */
  name: PropTypes.string,
  /** Function that is called to update field state when the input blurs. */
  onBlur: PropTypes.func,
  /** Function that is called to update field state when the input value changes. */
  onChange: PropTypes.func,
  /** Function that is called to update field state when the input focuses. */
  onFocus: PropTypes.func,
  /** Input placeholder */
  placeholder: PropTypes.string,
  /** Value of the input */
  value: PropTypes.string,
  /** prop to display/hide the password input */
  showHidePasswordLink: PropTypes.bool
};
export { PasswordInput };